module.exports = "<div class=q-marg-all-xs-at-md> <a href=\"{%=renderURL %}&{%- portletNamespace %}{%- idName %}={%- id %}\"> {%- displayVal %} </a> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/utilities/filtersutil/html/detailLinkHTML.html
// module id = 84
// module chunks = 1